/* The Video tab in the studio (sections/me-v-pack.liquid, [data-mxv]). Was its own page (me-v-video.liquid, unpublished).
   - Card previews: a stepped loop through real render frames (data-mxv-loop).
   - "Make one" opens the video editor (me-reveal.js) for that template. Logged out: log in first.
   - Previews: POST /vrender full=0, small real renders, free (capped per day by the worker).
   - Download: POST /vunlock spends one paid video on this video id; then /vrender full=1 swaps in full-size renders
     before the MP4 is made. No paid video left: their photos (already uploaded, kept a day by the worker) and the
     template are saved in localStorage 'mx-video-resume' and checkout opens in a NEW TAB, so the editor stays where
     it is. It then waits for the payment (payWait: a fresh token from this section, then /vunlock again) and carries
     straight on into the download. Shopify's thank-you page is a dead end on Basic, so nothing may depend on it
     (21 Sep, Kaitlin: "once i buy a video… it doesnt take me back to the video").
     If the browser blocks the tab, it falls back to checkout in this tab, and after paying me-after-checkout brings
     them back with ?resume=1 and the editor reopens with their photos. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mxv]');
  if (!root) { return; }
  var d = root.dataset, endpoint = (d.endpoint || '').replace(/\/$/, ''), token = d.token || '';
  var RESUME = 'mx-video-resume', videosLeft = null, images = null, handle = null;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- card previews ---- */
  /* In the studio the cards sit in a hidden tab, so a loop only loads its frames once it's on screen. */
  function loop(el) {
    var frames = el.getAttribute('data-mxv-loop').split(',').filter(Boolean), img = el.querySelector('img');
    var hold = Number(el.getAttribute('data-mxv-hold')) || 0, i = 0;
    if (reduce || frames.length < 2) { return; }
    frames.forEach(function (u) { var p = new Image(); p.src = u; });
    (function next() {
      i = (i + 1) % frames.length; img.src = frames[i];
      setTimeout(next, i === frames.length - 1 && hold ? hold : 330);
    })();
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-mxv-loop]'), function (el) {
    if (!('IntersectionObserver' in window)) { loop(el); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); loop(el); }
    });
    io.observe(el);
  });

  function uuid() {
    if (window.crypto && crypto.randomUUID) { return crypto.randomUUID(); }
    return 'xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx'.replace(/x/g, function () { return (Math.random() * 16 | 0).toString(16); });
  }
  /* One unlock at a time for a video, whatever asks: the Download button, payWait's poll and the tab coming back from
     checkout all share this (23 Sep). Two at once could pay twice; the worker refunds the loser, but not asking twice
     is better. */
  var unlocking = {}, openMockup = '';
  function unlock(video, arts) {
    if (unlocking[video]) { return unlocking[video]; }
    unlocking[video] = post('/vunlock', { token: token, video: video, mockup: openMockup, arts: JSON.stringify(arts || []) })
      .then(function (res) { delete unlocking[video]; return res; }, function (e) { delete unlocking[video]; throw e; });
    return unlocking[video];
  }
  function post(path, fields) {
    var body = new FormData();
    Object.keys(fields).forEach(function (k) { body.append(k, fields[k]); });
    return fetch(endpoint + path, { method: 'POST', body: body }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (b) { return { ok: r.ok, status: r.status, b: b }; });
    });
  }
  function fail(res, fallback) {
    var e = new Error(res.b.error || fallback);
    if (res.status === 401) { e.link = { href: d.login, label: 'Log in' }; }
    return e;
  }
  /* The token is signed by Liquid when the page is rendered, so a video bought after that isn't in it. Ask Shopify
     to render this section again (Section Rendering API) and read the new token out of it. */
  function freshToken() {
    var sec = root.closest('[id^="shopify-section-"]');
    if (!sec) { return Promise.resolve(token); }
    var id = sec.id.replace('shopify-section-', '');
    var url = location.pathname + '?sections=' + encodeURIComponent(id) + '&_=' + Date.now();
    return fetch(url, { cache: 'no-store', credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var html = j && j[id];
      if (!html) { return token; }
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mxv]');
      var t = el && el.getAttribute('data-token');
      if (t) { token = t; root.setAttribute('data-token', t); }
      return token;
    }).catch(function () { return token; });
  }

  /* Checkout is open in another tab. Every few seconds, and straight away whenever they come back to this tab, get a
     fresh token and try the unlock again. /vunlock answers ok if a bought video is there to spend OR this video is
     already unlocked (say the resume path in the other tab got there first), so it can't wait forever on a spend
     that already happened. Gives up after 20 minutes with a way to try again. */
  /* win: the checkout window. If they close it without paying, stop waiting and say so (one last check first,
     in case the payment landed as they closed it). */
  /* arts: the photos this video is being paid for, so the unlock covers exactly them (23 Sep) */
  function payWait(video, win, ctl, arts) {
    var closedAt = 0;
    var W = function () { return typeof win === 'function' ? win() : win; };
    return new Promise(function (resolve, reject) {
      if (ctl) { ctl.cancel = function () { stop(); reject(new Error('Payment cancelled. Press Download video whenever you’re ready.')); }; }
      var done = false, timer = null, busy = false, started = Date.now();
      function stop() { done = true; clearTimeout(timer); window.removeEventListener('focus', check); document.removeEventListener('visibilitychange', onVis); }
      function onVis() { if (!document.hidden) { check(); } }
      function later() { if (!done) { clearTimeout(timer); timer = setTimeout(check, W() && W().closed ? 1500 : 4000); } }
      function check() {
        if (done || busy) { return; }
        if (Date.now() - started > 20 * 60 * 1000) {
          stop();
          var e = new Error('No payment has come through yet. If you paid, press Download video again.');
          e.link = { href: '/cart/' + d.variant + ':1', label: 'Open checkout' };
          reject(e); return;
        }
        busy = true;
        freshToken().then(function () { return unlock(video, arts); }).then(function (res) {
          busy = false;
          if (done) { return; }
          if (res.ok) { stop(); resolve(res); return; }
          if (W() && W().closed) {
            if (!closedAt) { closedAt = Date.now(); }
            else if (Date.now() - closedAt > 3000) {
              stop();
              var c = new Error('Checkout was closed before paying. Press Download video to open it again.');
              reject(c); return;
            }
          }
          later();
        }, function () { busy = false; later(); });
      }
      window.addEventListener('focus', check);
      document.addEventListener('visibilitychange', onVis);
      later();
    });
  }

  /* one credit system (21 Sep): a video is 20 credits, from the same balance as mockups */
  var VIDEO_CREDITS = 20;
  function label(unlocked, free) {
    if (unlocked || videosLeft === null) { return 'Download video'; }
    if (free) { return 'Download video · Free'; }
    /* a video they've already paid for is waiting: say so, so they don't worry about paying twice (21 Sep) */
    if (videosLeft > 0) { return 'Download video · ' + videosLeft + ' already paid'; }
    return 'Download video · ' + VIDEO_CREDITS + ' credits';
  }
  /* the image packs, from the studio (data-buy on [data-lib]: "price|credits|variant~…") */
  function packs() {
    var lib = document.querySelector('[data-lib]');
    return ((lib && lib.getAttribute('data-buy')) || '').split('~').filter(Boolean).map(function (x) {
      var p = x.split('|'); return { price: p[0], credits: Number(p[1]) || 0, variant: p[2] };
    }).filter(function (p) { return p.variant && p.credits; });
  }

  /* Not enough images to unlock (21 Sep): our own pop-up on the page with their video, what they get, and ways to
     top up: the image packs (a pack covers videos and images alike) or just this video for $19. Checkout opens from
     the button they tap (it has to be a real click for the browser to allow the window). Keep editing, Esc or a
     tap outside just closes it. */
  function askToPay(openCheckout, small, have) {
    return new Promise(function (resolve, reject) {
      var cv = document.querySelector('.mx-sheet__canvas'), pic = '';
      try { pic = cv ? cv.toDataURL('image/jpeg', .85) : ''; } catch (e) { pic = ''; }
      var meta = ((document.querySelector('.mx-sheet [data-meta]') || {}).textContent || '').match(/\d+\s*×\s*\d+/);
      var box = document.createElement('div');
      box.className = 'mx-pay'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Unlock your video');
      /* credits only (21 Sep, Kaitlin: "why does video still say 19"): the top-ups as coin stacks, what each one
         makes, and how close they already are */
      var list = packs(), mid = list.length > 1 ? 1 : 0;
      var opts = list.map(function (p, i) {
        var vids = Math.floor(p.credits / VIDEO_CREDITS), mocks = Math.floor(p.credits / 5);
        var coins = ''; for (var c = 0; c <= Math.min(2, i); c++) { coins += '<i class="mx-coin" aria-hidden="true"></i>'; }
        return '<button type="button" class="mx-pay__opt' + (i === mid ? ' is-pop' : '') + '" data-variant="' + p.variant + '">' +
          '<span class="mx-pay__stack s' + (Math.min(2, i) + 1) + '">' + coins + '</span>' +
          '<span class="mx-pay__what"><b>' + p.credits + ' credits</b><small>' + vids + (vids === 1 ? ' video' : ' videos') + ' or ' + mocks + ' mockups</small></span>' +
          (i === mid ? '<span class="mx-pay__tag">Most popular</span>' : '') +
          '<em>' + p.price + '</em></button>';
      }).join('');
      var hv = Math.max(0, Number(have) || 0), pctHave = Math.min(100, Math.round(hv / VIDEO_CREDITS * 100));
      box.innerHTML = '<div class="mx-pay__card">' +
        (pic ? '<div class="mx-pay__pic"><img alt="Your video" data-pic><span>The watermark comes off</span></div>' : '') +
        '<div class="mx-pay__body">' +
          '<p class="mx-pay__title">Get it <em>clean.</em></p>' +
          '<p class="mx-pay__lead">A video is <b>' + VIDEO_CREDITS + '</b><i class="mx-coin" aria-hidden="true"></i>credits, then it’s yours for good: full size' + (meta ? ' (' + meta[0] + ')' : '') + ', a GIF too, free changes.</p>' +
          '<div class="mx-pay__have"><div class="mx-pay__bar"><i style="width:' + pctHave + '%"></i></div><span>You have <b>' + hv + '</b> of ' + VIDEO_CREDITS + '</span></div>' +
          '<p class="mx-pay__pick">Top up to unlock it</p>' +
          '<div class="mx-pay__opts">' + opts + '</div>' +
          '<button type="button" class="mx-pay__no" data-no>Keep editing</button>' +
          '<p class="mx-pay__small">' + (small ? 'Secure Shopify checkout opens in a small window. It unlocks here the moment you’ve paid.' : 'Secure Shopify checkout opens in a new tab. Come back here after and it unlocks by itself.') + '</p>' +
        '</div></div>';
      if (pic) { box.querySelector('[data-pic]').src = pic; }
      var done = false;
      function close() {
        document.removeEventListener('keydown', onKey);
        box.classList.add('is-out'); setTimeout(function () { box.remove(); }, 250);
      }
      function no() { if (done) { return; } done = true; close(); reject(new Error('No problem. It’s saved in Your videos, press Download video when you’re ready.')); }
      function onKey(e) { if (e.key === 'Escape') { no(); } }
      Array.prototype.forEach.call(box.querySelectorAll('[data-variant]'), function (b) {
        b.addEventListener('click', function () {
          if (done) { return; } done = true;
          var w = null; try { w = openCheckout('/cart/' + b.getAttribute('data-variant') + ':1'); } catch (e) { w = null; }
          if (window.mxTrack) { window.mxTrack('buy_click'); }
          close(); resolve(w);
        });
      });
      box.querySelector('[data-no]').addEventListener('click', no);
      box.addEventListener('click', function (e) { if (e.target === box) { no(); } });
      document.addEventListener('keydown', onKey);
      document.body.appendChild(box);
      setTimeout(function () { var g = box.querySelector('[data-variant]'); if (g) { g.focus(); } }, 50);
    });
  }

  if (token) {
    fetch(endpoint + '/usage?token=' + encodeURIComponent(token)).then(function (r) { return r.json(); })
      .then(function (b) { if ('videosLeft' in b) { videosLeft = b.videosLeft; } if ('credits' in b) { images = (Number(b.credits) || 0) + (Number(b.freeLeft) || 0) * 5; } if (b.unlimited) { videosLeft = null; images = null; } })
      .catch(function () {});
  }

  /* ---- Your videos (21 Sep, Kaitlin: "it saves to a library they only access when they purchase") ----
     Every video is saved to their account after its preview (worker /vsave). The shelf sits above the templates:
     drafts and paid ones (theirs for good). Tapping one reopens the editor with
     its photos already in, nothing to upload again. */
  var shelfItems = [], shelf = null, shelfRow = null;
  var gridEl = root.querySelector('.mv-vid__grid');
  /* TEMPORARY, for filming (28 Sep, Kaitlin: "on my account umkaitlin@gmail.com mobile version can you remove
     'your videos' just for this account i am trying to film a video"). Her account only, phones only. Delete this
     and the FILMING list when the video is shot. */
  var FILMING = ['6928328359996'];
  var filming = FILMING.indexOf(String(token).split('.')[0]) > -1 && window.matchMedia && matchMedia('(max-width: 899px)').matches;
  /* In the MADE pane with the mockups, not above the templates (6 Oct, Kaitlin: "i think videos go in the MADE tab
     with a DRAFT label... and maybe no drafts at top of videos"). Inside .mv-pane--made, so whatever shows and
     hides that pane handles the shelf too, on a phone as well as a computer. */
  /* me-library.js builds the rail's panes, and it can run after this file, so the Made pane is looked up when the
     shelf is drawn rather than now. Until it exists the shelf sits where it used to, above the templates. */
  function toMade() {
    if (!shelf || shelf.classList.contains('is-rail')) { return; }
    var pane = document.querySelector('.mv-studio__rail .mv-pane--made');
    if (!pane) { return; }
    shelf.classList.add('is-rail'); pane.appendChild(shelf);
  }
  if (token && gridEl && !filming) {
    shelf = document.createElement('section'); shelf.className = 'mv-vlib'; shelf.hidden = true; shelf.setAttribute('aria-label', 'Your videos');
    /* No note (23 Sep, Kaitlin: "remove this label"); nothing expires, so there is nothing to warn about. */
    shelf.innerHTML = '<div class="mv-vlib__head"><p class="mv-vlib__title">Your videos</p></div>' +
      '<div class="mv-vlib__row" data-vlib-row></div>';
    gridEl.parentNode.insertBefore(shelf, gridEl);
    toMade();
    shelfRow = shelf.querySelector('[data-vlib-row]');
    fetch(endpoint + '/vlist?token=' + encodeURIComponent(token)).then(function (r) { return r.json(); })
      .then(function (b) {
        shelfItems = (b.videos || []).filter(function (v) { return root.querySelector('[data-mxv-open="' + v.m + '"]'); });
        if ('credits' in b) { images = b.credits; }
        drawShelf();
      }).catch(function () {});
  }
  function ago(t) {
    var m = Math.round((Date.now() - (t || 0)) / 60000);
    if (m < 2) { return 'just now'; } if (m < 60) { return m + ' min ago'; }
    var h = Math.round(m / 60); if (h < 24) { return h + (h === 1 ? ' hour ago' : ' hours ago'); }
    var dd = Math.round(h / 24); return dd + (dd === 1 ? ' day ago' : ' days ago');
  }
  function cardPhoto(m) {
    var b = root.querySelector('[data-mxv-open="' + m + '"]');
    if (!b) { return ''; }
    var wrap = b.parentNode, loop = null;
    for (var i = 0; i < 4 && wrap && !loop; i++) { loop = wrap.querySelector('[data-mxv-loop]'); wrap = wrap.parentNode; }
    if (loop) {
      var first = (loop.getAttribute('data-mxv-loop') || '').split(',').filter(Boolean)[0];
      if (first) { return first; }
      var li = loop.querySelector('img');
      if (li) { return li.getAttribute('src') || ''; }
    }
    var any = b.parentNode && b.parentNode.querySelector('img');
    return any ? (any.getAttribute('src') || '') : '';
  }
  /* One Made list for photos and videos (3 Nov, Kaitlin: "just mix the videos with photos in made tab dont separate"):
     in the studio the cells go to me-library.js (window.mxMadeVideos + an mx:made event), which sorts them in with
     the photos by date. The shelf itself only shows where there is no Made tray. */
  var mixed = !!document.querySelector('[data-lib-tray-grid]');
  function drawShelf() {
    if (!shelf) { return; }
    toMade();
    shelfRow.innerHTML = '';
    var cells = [];
    shelfItems.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'mv-vlib__item' + (v.u ? ' is-yours' : '');
      var pic = document.createElement('span'); pic.className = 'mv-vlib__pic';
      /* The saved thumbnail is a Dynamic Mockups export link and those die after 24 hours, so anything older than a
         day came up blank (23 Sep, Kaitlin: "why are they borken"). Fall back to the template's own card photo. */
      /* Take the card's photo from the MARKUP, not from a loaded <img> (6 Oct, Kaitlin: "its glitching").
         The cards below lazy-load, so at the moment the shelf draws their currentSrc is usually '' and the
         fallback produced a grey box. data-mxv-loop's first frame is there from the start. */
      var cardSrc = cardPhoto(v.m);
      var im = document.createElement('img'); im.alt = ''; im.loading = 'lazy';
      im.addEventListener('error', function () { if (cardSrc && im.src !== cardSrc) { im.src = cardSrc; } });
      im.src = v.th || cardSrc;
      if (im.src) { pic.appendChild(im); }
      var badge = document.createElement('span'); badge.className = 'mv-vlib__badge'; badge.textContent = v.u ? (mixed ? 'Video' : 'Yours') : 'Draft'; pic.appendChild(badge);
      var num = document.createElement('span'); num.className = 'mv-vlib__num'; num.textContent = String(shelfItems.indexOf(v) + 1).padStart(2, '0');
      var name = document.createElement('span'); name.className = 'mv-vlib__name'; name.textContent = v.n || 'Video';
      b.appendChild(num);
      var when = document.createElement('span'); when.className = 'mv-vlib__when'; when.textContent = ago(v.up);
      b.appendChild(pic); b.appendChild(name); b.appendChild(when);
      b.addEventListener('click', function () {
        /* from the left menu, go to the Video tab first */
        var vt = document.querySelector('[data-lib-tab="video"]');
        if (vt && vt.getAttribute('aria-selected') !== 'true') { vt.click(); }
        reopen(v.video);
      });
      /* A paid video whose file we kept: straight to it, no re-making. The link's own page has the share sheet,
         which is the only way onto an iPhone's camera roll. A link, not nested in the button. */
      var cell = document.createElement('div'); cell.className = 'mv-vlib__cell';
      cell.appendChild(b);
      if (v.f && v.k) {
        var get = document.createElement('a'); get.className = 'mv-vlib__get'; get.href = endpoint + '/v/' + v.k;
        get.target = '_blank'; get.rel = 'noopener'; get.textContent = 'Save';
        get.setAttribute('aria-label', 'Save the ' + (v.n || 'video'));
        cell.appendChild(get);
      }
      cell._at = v.up || 0;
      cells.push(cell);
      if (!mixed) { shelfRow.appendChild(cell); }
    });
    shelf.hidden = mixed || !shelfItems.length;
    if (mixed) { window.mxMadeVideos = cells; document.dispatchEvent(new Event('mx:made')); }
  }
  /* Saving the same video again UPDATES it where it sits. It used to be removed and unshifted to the front,
     so every re-render reordered the shelf and the YOURS / DRAFT badges appeared to jump between cards
     (6 Oct, Kaitlin: "its glitching between saying yours and draft"). Only a genuinely new video goes first. */
  function remember(v) {
    var at = -1;
    shelfItems.forEach(function (x, i) { if (x.video === v.video) { at = i; } });
    if (at > -1) { shelfItems[at] = v; } else { shelfItems.unshift(v); }
    drawShelf();
  }
  /* A template in Mine is free for good (3 Nov, Kaitlin: "free edits forever for mine stuff"): once they have paid
     for one video on it, every new video on it costs nothing. The worker decides; this only words the button. */
  function mineTemplate(mockup, id) { return shelfItems.some(function (x) { return x.u && x.m === mockup && x.video !== id; }); }
  function markYours(id) { shelfItems.forEach(function (x) { if (x.video === id) { x.u = 1; } }); drawShelf(); }
  function markSaved(id, link) { shelfItems.forEach(function (x) { if (x.video === id) { x.f = 1; x.k = link.split('/').pop(); } }); drawShelf(); }
  function reopen(id) {
    note('Opening your video…');
    fetch(endpoint + '/vget?token=' + encodeURIComponent(token) + '&video=' + encodeURIComponent(id)).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, b: b }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.b.error || 'That video couldn’t be opened.'); }
        var e = res.b, btn = root.querySelector('[data-mxv-open="' + e.mockup + '"]');
        if (!btn) { throw new Error('That video couldn’t be opened.'); }
        return Promise.all(e.arts.map(function (a, i) {
          return fetch(endpoint + '/art/' + a).then(function (r) { if (!r.ok) { throw new Error('Its photos could not be found.'); } return r.blob(); })
            .then(function (b) { return new File([b], 'photo-' + (i + 1) + '.' + ((b.type.split('/')[1] || 'jpg').replace('jpeg', 'jpg')), { type: b.type || 'image/jpeg' }); });
        })).then(function (files) {
          note('');
          var many = btn.getAttribute('data-mode') === 'stack' || (btn.getAttribute('data-mode') === 'parts' && Number(btn.getAttribute('data-max')) > 1);
          open(btn, many ? files : files.slice(0, 1), e.video, e.unlocked ? 'From your videos. It’s unlocked, so Download video is free.' : 'From your videos.', { arts: e.arts, unlocked: !!e.unlocked });
        });
      })
      .catch(function (err) { note(err.message || 'That video couldn’t be opened.'); });
  }

  /* ---- the editor for one template ---- */
  /* ---- doily crumple (1 Nov, Kaitlin: "publish the second row one as a video template") ----
     Not a Dynamic Mockups render: their photo is laid on the flat doily and carried into each scrunched shot by a
     fold map, here in the page, so a preview costs nothing. Each shot n is two pictures, base B and tone K, and
     out = B + K * photo(fold map), the Photopea build Kaitlin picked (photo on Multiply over a 70% Screen of the
     paper). motion-lab/doily/bake.py makes the pictures and me-video-doily.js (the maps). */
  var doilyData = null;
  function doilyScript(src) {
    if (window.MeDoilyData) { return Promise.resolve(window.MeDoilyData); }
    if (doilyData) { return doilyData; }
    doilyData = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.onload = function () { resolve(window.MeDoilyData); };
      s.onerror = function () { doilyData = null; reject(new Error('The doily didn’t load. Try again.')); };
      document.head.appendChild(s);
    });
    return doilyData;
  }
  function pixels(img, w, h, sx, sy, sw, sh) {
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var g = c.getContext('2d', { willReadFrequently: true });
    g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
    if (sw) { g.drawImage(img, sx, sy, sw, sh, 0, 0, w, h); } else { g.drawImage(img, 0, 0, w, h); }
    return g.getImageData(0, 0, w, h);
  }
  function picture(src) {
    return new Promise(function (resolve, reject) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { resolve(im); }; im.onerror = function () { reject(new Error('The doily didn’t load. Try again.')); };
      im.src = src;
    });
  }
  /* one shot: B + K * their photo, sampled through the fold map (a grid, every `step` px, of where that point sits
     on the photo, 0..1 across it), both bilinear */
  function doilyShot(D, n, art, base, tone) {
    var W = D.w, H = D.h, step = D.step, gw = D.gw, sc = D.scale;
    var bin = atob(D.maps[n - 1]), bytes = new Uint8Array(bin.length);
    for (var b = 0; b < bin.length; b++) { bytes[b] = bin.charCodeAt(b); }
    var grid = new Int16Array(bytes.buffer), B = pixels(base, W, H), K = pixels(tone, W, H).data;
    var o = B.data, A = art.data, aw = art.width, ah = art.height;
    for (var y = 0; y < H; y++) {
      var gy = y / step, j0 = Math.floor(gy), fy = gy - j0;
      for (var x = 0; x < W; x++) {
        var i = (y * W + x) * 4, k = K[i] / 255;
        if (k < .004) { continue; }
        var gx = x / step, i0 = Math.floor(gx), fx = gx - i0;
        var p00 = (j0 * gw + i0) * 2, p01 = p00 + 2, p10 = p00 + gw * 2, p11 = p10 + 2;
        var s = ((grid[p00] * (1 - fx) + grid[p01] * fx) * (1 - fy) + (grid[p10] * (1 - fx) + grid[p11] * fx) * fy) / sc;
        var t = ((grid[p00 + 1] * (1 - fx) + grid[p01 + 1] * fx) * (1 - fy) + (grid[p10 + 1] * (1 - fx) + grid[p11 + 1] * fx) * fy) / sc;
        var u = Math.max(0, Math.min(aw - 1.001, s * aw - .5)), v = Math.max(0, Math.min(ah - 1.001, t * ah - .5));
        var u0 = u | 0, v0 = v | 0, du = u - u0, dv = v - v0, q = (v0 * aw + u0) * 4, r = q + aw * 4;
        for (var ch = 0; ch < 3; ch++) {
          var c = (A[q + ch] * (1 - du) + A[q + 4 + ch] * du) * (1 - dv) + (A[r + ch] * (1 - du) + A[r + 4 + ch] * du) * dv;
          o[i + ch] = Math.min(255, o[i + ch] + k * c);
        }
      }
    }
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    cv.getContext('2d').putImageData(B, 0, 0);
    return new Promise(function (resolve) { cv.toBlob(function (bl) { resolve(URL.createObjectURL(bl)); }, 'image/jpeg', .92); });
  }
  /* the photo, cut to the doily's shape (cover, centred) at about the doily's own size */
  function doilyArt(D, file) {
    var url = URL.createObjectURL(file);
    return picture(url).then(function (im) {
      URL.revokeObjectURL(url);
      var aw = 900, ah = Math.round(aw / D.aspect), iw = im.naturalWidth, ih = im.naturalHeight;
      var sw = Math.min(iw, ih * D.aspect), sh = sw / D.aspect;
      return pixels(im, aw, ah, (iw - sw) / 2, (ih - sh) / 2, sw, sh);
    });
  }
  /* scrunched to flat and back again (1-2-…-6-…-2), so the loop has no jump */
  function doilyFrames(btn, file, onStep) {
    var shots = (btn.getAttribute('data-doily-frames') || '').split(',').map(function (x) { return x.split('|'); });
    return doilyScript(btn.getAttribute('data-doily')).then(function (D) {
      return doilyArt(D, file).then(function (art) {
        var urls = [], done = 0;
        if (onStep) { onStep(0, shots.length); }
        return shots.reduce(function (chain, pair, k) {
          return chain.then(function () { return Promise.all([picture(pair[0]), picture(pair[1])]); })
            .then(function (im) { return doilyShot(D, k + 1, art, im[0], im[1]); })
            .then(function (u) { urls.push(u); done++; if (onStep) { onStep(done, shots.length); } });
        }, Promise.resolve()).then(function () { return urls.concat(urls.slice(1, -1).reverse()); });
      });
    });
  }

  function open(btn, photos, videoId, message, known) {
    if (!window.MeReveal) { note('The editor didn’t load. Refresh the page and try again.'); return; }
    /* Tapping a saved video while an editor is already open used to do nothing you could see: the new editor
       opened, the old one's onClose then ran history.back() and closed it again (6 Oct, Kaitlin: "why cant i
       click into any of these"). Close the old one first, with the mount and history entry left alone. */
    if (handle) { swapping = true; try { handle.close(); } catch (e) { /* ignore */ } swapping = false; }
    /* In the studio, start with the image they've already added there. Signed out there is nothing to start with:
       the editor opens empty and asks for the account at the first photo (23 Sep, Kaitlin: "let them go into the
       video editor first and then when they go uplaod photos then hit them with the pop up"). */
    if (!token) { photos = null; }
    else if (!photos && window.mxStudioFile && window.mxStudioFile()) { photos = [window.mxStudioFile()]; }
    var mockup = btn.getAttribute('data-mxv-open'), mode = btn.getAttribute('data-mode');
    /* series: one photo, a fixed run of templates (data-frames), each a frame after the blank (e.g. the envelope) */
    var series = mode === 'series' ? (btn.getAttribute('data-frames') || '').split(',').filter(Boolean) : null;
    /* data-max on a parts card: they can add up to that many photos and the wall re-pastes itself with the next
       one each pass (Kaitlin, 20 Sep: "if they add like 5 and then it goes to the next one"). One photo behaves
       exactly as before. Each photo is its own render of the whole template. */
    var trayMax = Math.max(1, Number(btn.getAttribute('data-max')) || 1);
    var doily = mode === 'doily', doilyFile = null, doilyMade = null;
    var multi = mode === 'stack' || !!series || doily || (mode === 'parts' && trayMax > 1);
    var video = videoId || uuid(), unlocked = !!(known && known.unlocked);
    var arts = new Map(), previews = new Map(), last = [];
    /* Refreshing the page used to throw the whole edit away (30 Sep, Kaitlin: "i refreshed while the lag happened
       and i lost my work"). The photos are already on the server, so all that has to survive is which template,
       which video id and which photo ids. Same key and shape as the checkout round-trip. */
    function keepWork() {
      if (!token || !last.length) { return; }
      try { localStorage.setItem(RESUME, JSON.stringify({ mockup: mockup, video: video, arts: last, at: Date.now() })); } catch (e) { /* ignore */ }
    }
    /* reopened from Your videos: its photos are already on the server */
    if (known && known.arts && photos) { photos.forEach(function (f, i) { if (known.arts[i]) { arts.set(f, Promise.resolve(known.arts[i])); } }); }

    /* each photo is uploaded once for this video */
    /* 21 Sep, Kaitlin: "the uploading bar doesn't work when I add a photo". It only moved when a whole photo finished,
       so one photo sat at 0% and then vanished. fetch can't report upload progress; XMLHttpRequest can, so uploads
       go through this and the bar follows the bytes. Held at 90% until the worker answers. */
    function upload(file, onProgress) {
      return new Promise(function (resolve, reject) {
        var body = new FormData(); body.append('token', token); body.append('image', file);
        var x = new XMLHttpRequest(); x.open('POST', endpoint + '/upload');
        if (x.upload && onProgress) { x.upload.onprogress = function (e) { if (e.lengthComputable && e.total) { onProgress(Math.min(.9, e.loaded / e.total * .9)); } }; }
        x.onload = function () {
          var b = {}; try { b = JSON.parse(x.responseText); } catch (e) { b = {}; }
          if (onProgress) { onProgress(1); }
          resolve({ ok: x.status >= 200 && x.status < 300, status: x.status, b: b });
        };
        x.onerror = function () { reject(new Error('Could not reach the studio. Check your connection and try again.')); };
        x.send(body);
      });
    }
    function artFor(file, onProgress) {
      if (arts.has(file)) { if (onProgress) { onProgress(1); } return arts.get(file); }
      if (!arts.has(file)) {
        arts.set(file, upload(file, onProgress).then(function (res) {
          if (!res.ok || !res.b.art) { throw fail(res, 'Could not save that photo. Try again.'); }
          return res.b.art;
        }).catch(function (e) { arts.delete(file); throw e; }));
      }
      return arts.get(file);
    }
    /* stack: frame k has photo k in the first design area and the ones before it in the areas behind, wrapping
       round. data-areas is how many the template has: 4 papers on the pile, 1 screen on the monitor (so it
       just changes). */
    /* data-alternate (the spiral pad, Kaitlin 20 Sep: "one image stays at top then bottom changes and then top
       changes rather than BOTH changing each time"): two pages, one turning at a time. Each beat puts the next
       photo on one page and leaves the other alone, swapping pages every beat. The loop only closes back on
       itself if the number of beats is even, so an odd number of photos runs twice round, which also puts every
       photo on both pages. */
    /* data-pile (the Paper pile, 24 Oct, Kaitlin: "they actually layer"): "uuid:sheets,…", a run of templates with one
       more sheet each. Beat j uses the (j+1)th, or the last once it runs out, with photo j on the top sheet and the
       ones before it on the sheets below, so the pile grows instead of the same pile changing. A frame carries its
       template as .m; each loop starts again from the single sheet. */
    var pile = (btn.getAttribute('data-pile') || '').split(',').filter(Boolean).map(function (x) {
      var p = x.split(':'); return { m: p[0], sheets: Math.max(1, Number(p[1]) || 1) };
    });
    function specs(ids) {
      if (mode === 'parts') { return ids.map(function (id) { return [id]; }); }
      if (mode !== 'stack') { return [[ids[0]]]; }
      if (pile.length) {
        return ids.map(function (_, j) {
          var p = pile[Math.min(j, pile.length - 1)], frame = [];
          for (var s = 0; s < p.sheets && s <= j; s++) { frame.push(ids[j - s]); }
          frame.m = p.m;
          return frame;
        });
      }
      var n = ids.length, areas = Math.max(1, Number(btn.getAttribute('data-areas')) || 4), out = [], k, i;
      if (btn.hasAttribute('data-alternate')) {
        for (k = 0; k < (n % 2 ? n * 2 : n); k++) {
          var fresh = ids[(k + 1) % n], held = ids[k % n];
          out.push(k % 2 ? [fresh, held] : [held, fresh]);
        }
        return out;
      }
      return ids.map(function (_, j) {
        var frame = [];
        for (i = 0; i < areas; i++) { frame.push(ids[((j - i) % n + n) % n]); }
        return frame;
      });
    }
    function render(ids, full, m) {
      m = m || mockup;
      var key = (full ? 'F' : 'P') + m + ids.join('|');
      if (!previews.has(key)) {
        previews.set(key, post('/vrender', { token: token, video: video, mockup: m, arts: JSON.stringify(ids), full: full ? '1' : '0' }).then(function (res) {
          if (!res.ok || !res.b.url) { throw fail(res, 'Could not make that just now. Try again.'); }
          return res.b.url;
        }).catch(function (e) { previews.delete(key); throw e; }));
      }
      return previews.get(key);
    }
    /* the editor shows a bar under step 1 while these upload, then one over the template while they render */
    function idsOf(files, onStep) {
      /* each photo's share of the bar, 0 to 1, summed across all of them */
      var part = files.map(function () { return 0; });
      function tell() { if (onStep) { onStep(part.reduce(function (a, b) { return a + b; }, 0), files.length, 'upload'); } }
      tell();
      return Promise.all(files.map(function (f, i) {
        return artFor(f, function (p) { part[i] = Math.max(part[i], p); tell(); });
      })).then(function (ids) { last = ids; return ids; });
    }
    /* every frame of the video for these photo ids: stack = one render per photo, series = the blank then one per template */
    /* onStep(done, total) drives the editor's load bar: every frame is its own render, so the count is real */
    function frames(ids, full, onStep) {
      var done = 0;
      function step(total) {
        return function (url) { done++; if (onStep) { onStep(done, total); } return url; };
      }
      /* the doily is made here in the page, once per photo; the clean download uses the same frames */
      if (doily) {
        if (!doilyMade || doilyMade.file !== doilyFile) { doilyMade = { file: doilyFile, urls: doilyFrames(btn, doilyFile, onStep) }; }
        else if (onStep) { onStep(1, 1); }
        return doilyMade.urls.catch(function (e) { doilyMade = null; throw e; });
      }
      if (series) {
        return Promise.all(series.map(function (m) { return render([ids[0]], full, m).then(step(series.length)); }))
          .then(function (urls) { return [btn.getAttribute('data-blank')].concat(urls); });
      }
      var list = specs(ids);
      if (onStep) { onStep(0, list.length); }
      return renderMany(list, full, step(list.length));
    }
    /* Every frame that isn't made yet goes to the worker in ONE request (up to 10 at a time, one request after
       another), and the worker sends them to Dynamic Mockups as one batch (21 Sep: separate requests at the same
       time were queued there, so a 2-photo mega screen took up to a minute; one batch takes about 5 seconds).
       Frames already made come from the same cache render() uses. */
    /* A pile frame names its own template (.m), so its frames go in one request per template. */
    function renderMany(list, full, each) {
      var keyOf = function (ids) { return (full ? 'F' : 'P') + (ids.m || mockup) + ids.join('|'); };
      var todo = [], seen = {};
      list.forEach(function (ids) { var k = keyOf(ids); if (!previews.has(k) && !seen[k]) { seen[k] = 1; todo.push(ids); } });
      var byTemplate = {}, chunks = [];
      todo.forEach(function (ids) { var m = ids.m || mockup; (byTemplate[m] = byTemplate[m] || []).push(ids); });
      Object.keys(byTemplate).forEach(function (m) {
        for (var c = 0; c < byTemplate[m].length; c += 10) { chunks.push(byTemplate[m].slice(c, c + 10)); }
      });
      var chain = Promise.resolve();
      chunks.forEach(function (chunk) {
        var batch = chain.then(function () {
          return post('/vrender', { token: token, video: video, mockup: chunk[0].m || mockup, arts: JSON.stringify(chunk[0]), sets: JSON.stringify(chunk), full: full ? '1' : '0' }).then(function (res) {
            var urls = res.b && res.b.urls;
            if (!res.ok || !urls || urls.length !== chunk.length) { throw fail(res, 'Could not make that just now. Try again.'); }
            return urls;
          });
        });
        chunk.forEach(function (ids, i) {
          var k = keyOf(ids);
          previews.set(k, batch.then(function (urls) { return urls[i]; }).catch(function (e) { previews.delete(k); throw e; }));
        });
        chain = batch.catch(function () {});
      });
      return Promise.all(list.map(function (ids) { return previews.get(keyOf(ids)).then(each); }));
    }

    function saveToShelf(urls) {
      var thumb = (series ? urls[1] : urls[0]) || '', name = btn.getAttribute('data-name') || '';
      post('/vsave', { token: token, video: video, mockup: mockup, arts: JSON.stringify(last), name: name, thumb: thumb }).catch(function () {});
      remember({ video: video, m: mockup, n: name, up: Date.now(), u: unlocked ? 1 : 0, th: thumb });
    }
    /* Pay first, then make (2 Nov, Kaitlin: "they don't even get to preview now… the only people who will get their
       videos are ones who have already paid for those credits"). Making the video spends the 20 credits, the same
       way tapping a photo template spends 5, and what they see is the clean full-size video, so there is no
       watermarked preview and no free render for someone who never pays. Short of credits: the top-up pop-up, then
       it carries on once the payment lands. */
    function pay() {
      if (unlocked) { return Promise.resolve(); }
      /* Browsers only open a window straight off a click, so checkout opens from the Pay button in askToPay. */
      /* 21 Sep, Kaitlin: "make the payment a pop up so they stay in the video tab". Shopify won't let its checkout
         sit inside the page, so on a computer it opens as a small window centred over this one; the editor stays
         put behind it, and the window closes itself once the payment comes through. Phones have no pop-up
         windows, so there it is a tab, closed the same way. */
      var cart = '/cart/' + d.variant + ':1', tab = null;
      var small = !(window.matchMedia && matchMedia('(pointer: coarse)').matches) && window.outerWidth > 700;
      function payWindow(url) {
        if (!small) { return window.open(url, '_blank'); }
        var w = 500, h = Math.min(860, (screen.availHeight || 900) - 60);
        var x = Math.max(0, (window.screenX || 0) + (window.outerWidth - w) / 2), y = Math.max(0, (window.screenY || 0) + (window.outerHeight - h) / 2);
        return window.open(url, 'mx-checkout', 'popup=yes,width=' + w + ',height=' + h + ',left=' + Math.round(x) + ',top=' + Math.round(y));
      }
      return unlock(video, last).then(function (res) {
        if (res.status === 402 || res.b.needVideo) {
          if (!packs().length) { throw new Error('Top-ups can’t be bought just yet. Check back soon.'); }
          try { localStorage.setItem(RESUME, JSON.stringify({ mockup: mockup, video: video, arts: last, at: Date.now() })); } catch (e) { /* ignore */ }
          return askToPay(function (url) { cart = url; return payWindow(url); }, small, res.b.credits).then(function (w) { tab = w; return res; });
        }
        return res;
      }).then(function (res) {
        if (res.status === 402 || res.b.needVideo) {
          if (!tab) { window.location.href = cart; return new Promise(function () {}); }
          try { tab.focus(); } catch (e) { /* ignore */ }
          if (handle) {
            handle.setBusyLabel('Waiting for your payment…');
            handle.setStatus(small ? 'Checkout is open in a small window. Pay there and your video makes itself here.' : 'Checkout is open in a new tab. Pay there, come back, and your video makes itself.', { href: cart, label: 'Checkout didn’t open?' });
          }
          /* on the loader: bring the checkout window back if it went behind, or stop waiting */
          var ctl = {};
          if (handle && handle.setWaiting) {
            handle.setWaiting([
              { label: 'Back to checkout', main: true, fn: function () { try { if (tab && !tab.closed) { tab.focus(); } else { tab = payWindow(cart); } } catch (e) { tab = null; } } },
              { label: 'Cancel', fn: function () { try { if (tab && !tab.closed) { tab.close(); } } catch (e) { /* ignore */ } if (ctl.cancel) { ctl.cancel(); } } }
            ]);
          }
          return payWait(video, function () { return tab; }, ctl, last).then(function (paid) {
            try { localStorage.removeItem(RESUME); } catch (e) { /* ignore */ }
            try { if (tab && !tab.closed) { tab.close(); } } catch (e) { /* ignore */ }
            try { window.focus(); } catch (e) { /* ignore */ }
            if (handle) { handle.setStatus(''); handle.setBusyLabel('Creating video'); }
            return paid;
          });
        }
        return res;
      }).then(function (res) {
        if (!res.ok) { throw fail(res, 'Could not unlock the video. Try again.'); }
        unlocked = true;
        if ('videosLeft' in res.b) { videosLeft = res.b.videosLeft; }
        if ('credits' in res.b) { images = res.b.credits; }
        markYours(video);
        /* Four words, not a paragraph (23 Sep, Kaitlin: "remove this copy maybe instead used 20 credits"). */
        if (res.b.paidWith === 'credits' && handle) { handle.setStatus('Used ' + VIDEO_CREDITS + ' credits.'); }
        try { window.dispatchEvent(new CustomEvent('mx:credits')); } catch (e) { /* ignore */ }
        if (handle) { handle.setExportLabel(label(true)); handle.setPaid(); }
      });
    }
    openMockup = mockup || '';
    var mineFree = !unlocked && mineTemplate(mockup, video);
    var opts = {
      blank: btn.getAttribute('data-blank'), map: btn.getAttribute('data-map') || undefined, template: btn.getAttribute('data-name'),
      /* data-size: the shape the editor opens on, where 9:16 would cut the template in half (the mega screen
         is a wide wall, so it starts on 4:5). They can still change it. */
      size: btn.getAttribute('data-size') || undefined,
      /* Nothing is made before it is paid for, so there is nothing to mark. Kept as a guard: if a frame ever does
         show before the unlock, it carries the mark. */
      watermark: !unlocked,
      markSrc: d.mark || undefined,
      /* the cost sits on the button that spends it, until it's spent */
      buildNote: unlocked ? '' : mineFree ? ' · Free' : ' · ' + VIDEO_CREDITS + ' credits',
      /* No separate "Download it again" (30 Sep, Kaitlin): once it is paid for the button just says what it does. */
      photos: photos, autoBuild: !!videoId, message: message, exportLabel: label(unlocked, mineFree), againLabel: 'Download video',
      /* Signed out, the first photo is where the account is asked for, not the card. */
      beforeUpload: function () { if (!token) { askAccount(btn); return false; } },
      costNote: 'A video is ' + VIDEO_CREDITS + ' credits. Changes after that are free, and it stays in Your videos.',
      priceLine: 'It lands here the moment you’ve paid.',
      render: function (input, onStep) {
        var files = multi ? input : [input];
        if (doily) { doilyFile = files[0]; }
        return idsOf(files, onStep).then(function (ids) { return pay().then(function () { return ids; }); })
          .then(function (ids) { return frames(ids, true, onStep); })
          .then(function (urls) { saveToShelf(urls); keepWork(); return multi ? urls : urls[0]; });
      },
      /* The finished video goes to their account (worker /vfile) and comes back as a link (23 Sep, Kaitlin: "it
         doesnt go anywhere or save anywhere? can it go somewhere like a server"). Only paid ones: a watermarked
         preview is not worth keeping, and the worker refuses it anyway. */
      keep: function (blob) {
        dropWork();
        if (!unlocked || !token) { return null; }
        if (blob.size > 24 * 1024 * 1024) { return null; }
        return post('/vfile', { token: token, video: video, file: new File([blob], 'video.mp4', { type: blob.type || 'video/mp4' }) })
          .then(function (res) {
            if (!res.ok || !res.b.link) { throw new Error(res.b.error || 'not kept'); }
            markSaved(video, res.b.link);
            return res.b.link;
          });
      },
      /* Made full size and paid for already, so this is normally just the frames from the cache. A video reopened
         from before the pay-first change can still be unpaid, so pay() runs here too. */
      beforeExport: function () {
        if (!last.length) { return Promise.reject(new Error('Add your photos first.')); }
        return pay().then(function () {
          /* tell the loader as each full-size frame lands, or the bar sits at its cap looking hung (30 Sep) */
          return frames(last, true, function (done, total) {
            if (handle && handle.setProgress) { handle.setProgress(done, total); }
          });
        }).then(function (urls) { return multi ? { frames: urls } : { full: urls[0] }; });
      }
    };
    /* data-zoom closes in on a small subject in its frame (the pad on its scanner bed), like the envelope does */
    if (mode === 'stack') { opts.stack = { min: 2, max: 10, zoom: Number(btn.getAttribute('data-zoom')) || undefined, each: pile.length > 0 }; }
    /* the tray, but the map still does the drawing (me-reveal partsMode) */
    if (mode === 'parts' && trayMax > 1) { opts.stack = { min: 1, max: trayMax }; }
    if (series) { opts.stack = { min: 1, max: 1, beat: .4, plays: 3, zoom: 1.35 }; }
    if (doily) { opts.stack = { min: 1, max: 1, beat: .25, plays: 3 }; }
    /* In the studio the editor opens inside the Video tab, not over everything (Kaitlin, 19 Sep: "don't make the video
       editor so far away"), and gets its own history entry so the browser's Back closes it instead of leaving. */
    if (host) {
      opts.mount = host;
      opts.onClose = function () {
        if (swapping) { handle = null; return; }
        handle = null; root.classList.remove('is-making'); back.hidden = true;
        if (overBtn) { overBtn.hidden = true; }
        if (pushed) { pushed = false; if (!popping) { history.back(); } }
      };
      root.classList.add('is-making'); back.hidden = false;
      if (overBtn) { overBtn.hidden = false; }
      if (!pushed) { try { history.pushState({ mxv: 1 }, '', location.pathname + location.search + '#video'); pushed = true; } catch (e) { /* ignore */ } }
      var scroller = root.closest('[data-lib-scroll]'); if (scroller) { scroller.scrollTop = 0; }
    }
    handle = window.MeReveal.open(opts);
    /* theirs already (reopened from Your videos): no watermark on the preview either */
    if (unlocked && handle && handle.setPaid) { handle.setPaid(); }
  }
  var host = root.querySelector('[data-mxv-host]'), back = root.querySelector('[data-mxv-back]'), pushed = false, popping = false;
  var overBtn = root.querySelector('[data-mxv-over]'), swapping = false;
  function dropWork() { try { localStorage.removeItem(RESUME); } catch (e) { /* ignore */ } }
  if (back) { back.addEventListener('click', function () { if (handle) { handle.close(); } }); }
  /* Throw the restored edit away on purpose. Quiet, beside the back link: it is the way out of a video that came
     back by itself, not something to hit by accident (30 Sep, Kaitlin: "a button that says like start over
     somewhere super subtle"). */
  if (overBtn) { overBtn.addEventListener('click', function () { dropWork(); if (handle) { handle.close(); } }); }
  window.addEventListener('popstate', function () {
    if (!handle || !pushed) { return; }
    popping = true; handle.close(); popping = false;
  });

  function note(t) { var el = root.querySelector('[data-mxv-note]'); el.textContent = t; el.hidden = !t; }
  /* Guests (the studio without an account, 21 Sep) see the videos and can open the editor. Making one needs an
     account, because the uploads and previews run on it, so the ask comes at the first photo, not at the card
     (23 Sep, Kaitlin: "hit them with the pop up but say create an account dont say all that other crap"). Four
     words, that video's own picture, and back to the Video tab once they're in. */
  function askAccount(btn) {
    var pic = btn.querySelector('img'), next = '/pages/creator-studio#video';
    if (window.mxTrack) { window.mxTrack('signup_open'); }
    var words = { heading: 'Create an account.', sub: '', photo: pic ? (pic.currentSrc || pic.src) : null };
    if (!window.mxSignIn || !window.mxSignIn(next, words)) { location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(next); }
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-mxv-open]'), function (btn) {
    btn.addEventListener('click', function () { open(btn); });
  });

  /* ---- put their photos back: after checkout, or after a plain refresh ---- */
  /* A refresh mid-edit used to lose the lot (30 Sep, Kaitlin: "i refreshed while the lag happened ... and i lost
     my work"). The photos are already on the server, so the editor can be rebuilt from the ids alone. Only on the
     Video tab, so someone who came to make a photo isn't dropped into the video editor, and only recent work:
     two hours after a refresh, twenty through checkout. */
  var paidReturn = /[?&]resume=1\b/.test(location.search);
  if (token && (paidReturn || location.hash === '#video')) {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(RESUME) || 'null'); } catch (e) { saved = null; }
    var maxAge = (paidReturn ? 20 : 2) * 60 * 60 * 1000;
    if (saved && saved.at > Date.now() - maxAge && Array.isArray(saved.arts) && saved.arts.length) {
      var rbtn = root.querySelector('[data-mxv-open="' + saved.mockup + '"]');
      if (rbtn) {
        if (paidReturn) { note('Thanks. Bringing your video back…'); }
        Promise.all(saved.arts.map(function (id, i) {
          return fetch(endpoint + '/art/' + id).then(function (r) { if (!r.ok) { throw new Error('gone'); } return r.blob(); })
            .then(function (b) { return new File([b], 'photo-' + (i + 1) + '.' + ((b.type.split('/')[1] || 'jpg').replace('jpeg', 'jpg')), { type: b.type || 'image/jpeg' }); });
        })).then(function (files) {
          note('');
          /* the paid trip is done with; a refresh keeps it, in case they refresh again */
          if (paidReturn) { try { localStorage.removeItem(RESUME); } catch (e) { /* ignore */ } }
          open(rbtn, rbtn.getAttribute('data-mode') === 'stack' ? files : files.slice(0, 1), saved.video,
            paidReturn ? 'Thanks. Your video is paid for. Press Download video.' : null);
        }).catch(function () {
          if (paidReturn) { note('Your video is paid for. Your photos have expired, so add them again and press Download video.'); }
          else { try { localStorage.removeItem(RESUME); } catch (e) { /* ignore */ } }
        });
      }
    }
  }
})();
